import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const Auth = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useUser();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(username, password);
            navigate('/');
        } catch (err) {
            setError(err.message || 'Ошибка входа');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#1E1E1E] py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full">
                <div>
                    <h2 className="mt-6 text-center text-2xl font-medium text-[#CCCCCC]">
                        Вход в систему
                    </h2>
                </div>
                <form className="mt-8" onSubmit={handleSubmit}>
                    <div className="bg-[#252526] rounded-lg p-6 border border-[#3E3E42] space-y-4">
                        <div>
                            <label htmlFor="username" className="block text-sm font-medium text-[#A0A0A0] mb-1">
                                Логин пользователя
                            </label>
                            <input
                                id="username"
                                name="username"
                                type="text"
                                required
                                className="appearance-none block w-full px-3 py-2 bg-[#2D2D30] border border-[#3E3E42] text-[#CCCCCC] rounded 
                                placeholder-[#6E6E6E] focus:outline-none focus:ring-2 focus:ring-[#007ACC] focus:border-transparent
                                transition-colors duration-200"
                                placeholder="Введите имя пользователя"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-[#A0A0A0] mb-1">
                                Пароль
                            </label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                className="appearance-none block w-full px-3 py-2 bg-[#2D2D30] border border-[#3E3E42] text-[#CCCCCC] rounded 
                                placeholder-[#6E6E6E] focus:outline-none focus:ring-2 focus:ring-[#007ACC] focus:border-transparent
                                transition-colors duration-200"
                                placeholder="Введите пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        {error && (
                            <div className="text-[#F48771] text-sm">
                                {error}
                            </div>
                        )}

                        <div className="mt-6">
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full flex justify-center py-2 px-4 border border-[#3E3E42] rounded
                                text-sm font-medium text-[#CCCCCC] bg-[#2D2D30] hover:bg-[#3E3E42]
                                focus:outline-none focus:ring-2 focus:ring-[#007ACC] focus:ring-opacity-50
                                disabled:opacity-50 transition-colors duration-200"
                            >
                                {loading ? 'Вход...' : 'Войти'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Auth;